import { apiRequestEnvelope } from "./apiClient";

export type OnboardingStatus =
  | "NOT_STARTED"
  | "IN_PROGRESS"
  | "COMPLETED"
  | "PAUSED"
  | "SKIPPED";

export interface Onboarding {
  flowCode: string;
  version: number;
  status: OnboardingStatus;
  currentStepId: string | null;
  startedAt: string | null;
  completedAt: string | null;
}

export interface OnboardingUpdate {
  status?: OnboardingStatus;
  currentStepId?: string;
}

// M20 (ADR-042 D4) — стан навчального wizard. Клієнт трактує помилки цих
// викликів fail-soft: онбординг ніколи не блокує застосунок.
export const onboardingApi = {
  get: async (signal?: AbortSignal): Promise<Onboarding> => {
    const { data } = await apiRequestEnvelope<{ onboarding: Onboarding }>(
      "/api/users/me/onboarding",
      { signal },
    );
    return data.onboarding;
  },
  update: async (input: OnboardingUpdate): Promise<Onboarding> => {
    const { data } = await apiRequestEnvelope<{ onboarding: Onboarding }>(
      "/api/users/me/onboarding",
      { method: "PATCH", body: input },
    );
    return data.onboarding;
  },
  restart: async (): Promise<Onboarding> => {
    const { data } = await apiRequestEnvelope<{ onboarding: Onboarding }>(
      "/api/users/me/onboarding/restart",
      { method: "POST" },
    );
    return data.onboarding;
  },
};
